
const FeedbackData = [
    {
        id: 1,
        rating: 8,
        text: "this is the first rating "
    },
    {
        id: 2,
        rating: 9,
        text: "service was good user interface is very good."
    },
    {
        id: 3,
        rating: 7,
        text: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sunt, ipsam."
    },
]

export default FeedbackData
